export default "__VITE_ASSET__XVPswOAB4hTpu4N6dOGvyw__"